import React from 'react';
import ReactTooltip from 'react-tooltip';

interface Props {
  total?: number;
  text: string;
  recurring: boolean;
  totalNotYetAvailable: boolean;
  totalNotYetAvailableText: string;
  includeTax?: boolean;
  tooltip?: boolean;
}

function SummaryTotal({
  total = 0,
  text,
  recurring,
  totalNotYetAvailable,
  totalNotYetAvailableText,
  includeTax,
  tooltip,
}: Props) {
  const displayedTotal = Math.round(total * 100) / 100;
  return (
    <div className='payment-form-summary-total'>
      <p>
        {text}
        {tooltip ? (
          <>
            <i
              style={{ marginLeft: '4px' }}
              className='fas fa-info-circle'
              data-for='sales-tax-tooltip'
              data-tip='Taxes are calculated after discounts and are based on your billing address.'
            ></i>
            <ReactTooltip id='sales-tax-tooltip' className='tooltip' place='top' />
          </>
        ) : (
          ''
        )}
      </p>
      <p
        className={`payment-form-summary-number ${
          totalNotYetAvailable ? 'payment-form-summary-number-loading' : ''
        }`}
      >
        {totalNotYetAvailable ? (
          totalNotYetAvailableText
        ) : (
          <>
            {/* Display negative sign before $ - used when displaying proration discount for legacy yearly => ZPM */}
            {displayedTotal >= 0 ? (
              <>${displayedTotal.toFixed(2)}</>
            ) : (
              <>-${(displayedTotal * -1).toFixed(2)}</>
            )}
          </>
        )}
        <span>{`${recurring ? ' / Month' : ''}${includeTax ? ' + Tax' : ''}`}</span>
      </p>
    </div>
  );
}

export default SummaryTotal;
